import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import defined from "terriajs-cesium/Source/Core/defined";
import ViewerMode from "../../../Models/ViewerMode";
import Box from "../../../Styled/Box";
import Icon from "../../../Styled/Icon";
import Text from "../../../Styled/Text";
import { useViewState } from "../../Context";
import parseCustomHtmlToReact from "../../Custom/parseCustomHtmlToReact";
import MapIconButton from "../../MapIconButton/MapIconButton";

// Use padding to avoid other UI elements
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AttributionsContainer = styled(Text).withConfig({
  displayName: "BottomLeftBar__AttributionsContainer",
  componentId: "sc-17xn5s3-0"
})(["text-shadow:0 0 2px #000000;padding-left:8px;padding-right:56px;@media (max-width:", "px){padding-right:8px;padding-bottom:32px;}"], props => props.theme.mobile);
const shouldShowPlayStoryButton = viewState => viewState.terria.configParameters.storyEnabled && defined(viewState.terria.stories) && viewState.terria.stories.length > 0 && viewState.useSmallScreenInterface &&
// Don't show story button if story panel is visible
viewState.storyShown !== true;
const BottomLeftBar = observer(() => {
  var _viewState$terria$ces;
  const {
    t
  } = useTranslation();
  const viewState = useViewState();
  const screenDataAttributions = (_viewState$terria$ces = viewState.terria.cesium) === null || _viewState$terria$ces === void 0 ? void 0 : _viewState$terria$ces.cesiumScreenDataAttributions;
  const isNotificationActive = viewState.terria.notificationState.currentNotification;
  const isUsingGooglePhotorealistic3dTiles = viewState.terria.mainViewer.viewerMode === ViewerMode.Cesium && viewState.terria.workbench.items.filter(i => i.type === "3d-tiles").some(i => {
    var _i$url;
    return ((_i$url = i.url) === null || _i$url === void 0 ? void 0 : _i$url.startsWith("https://tile.googleapis.com/v1/3dtiles/root.json")) && i.show;
  });
  return /*#__PURE__*/_jsxs(Box, {
    padded: true,
    children: [shouldShowPlayStoryButton(viewState) ? /*#__PURE__*/_jsx(Box, {
      paddedHorizontally: 2,
      children: /*#__PURE__*/_jsx(MapIconButton, {
        title: t("story.playStory"),
        neverCollapse: true,
        iconElement: () => /*#__PURE__*/_jsx(Icon, {
          glyph: Icon.GLYPHS.playStory
        }),
        onClick: () => viewState.runStories(),
        primary: !isNotificationActive,
        children: t("story.playStory")
      })
    }) : null, isUsingGooglePhotorealistic3dTiles && /*#__PURE__*/_jsx("img", {
      height: "18px",
      style: {
        paddingLeft: "8px"
      },
      src: "build/TerriaJS/images/google_on_non_white_hdpi.png"
    }), !!(screenDataAttributions !== null && screenDataAttributions !== void 0 && screenDataAttributions.length) && /*#__PURE__*/_jsx(AttributionsContainer, {
      textLight: true,
      mini: true,
      children: screenDataAttributions.flatMap((attributionHtml, i) => [/*#__PURE__*/_jsx("span", {
        children: parseCustomHtmlToReact(attributionHtml)
      }, attributionHtml), /*#__PURE__*/_jsx("span", {
        children: " \u2022 "
      }, "delimiter-".concat(i))]).slice(0, -1)
    })]
  });
});
export default BottomLeftBar;